{
  "version": 1,
  "asset_id": "be0b924a-ebaa-4888-823a-8a9adc7c6d33",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/be0b924a-ebaa-4888-823a-8a9adc7c6d33/publications-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/be0b924a-ebaa-4888-823a-8a9adc7c6d33/publications-hero.webp",
  "original_filename": "publications-hero.webp",
  "size": 40602,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:23Z"
}
